// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox-module--container--59aa32","label":"Checkbox-module--label--c82d1d"};